module.exports = __webpack_public_path__ + "static/media/hw_ki_7.77062a38.flv";